import React, { useState } from "react";
import Sidebar from "./Sidebar";
import AnalyticsTab from "./AnalyticsTab";
import UserManagement from "./UserManagement";
import "./Dashboard.css";

const TABS = {
  analytics: "analytics",
  users: "users",
};

/**
 * Main dashboard layout with sidebar navigation and content area.
 */
function Dashboard() {
  const [activeTab, setActiveTab] = useState(TABS.analytics);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="dashboard">
      {/* Mobile hamburger */}
      <button
        className="dashboard-hamburger"
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
      >
        <span />
        <span />
        <span />
      </button>

      {/* Overlay for mobile sidebar */}
      {sidebarOpen && (
        <div className="dashboard-overlay" onClick={closeSidebar} />
      )}

      <Sidebar
        activeTab={activeTab}
        onTabChange={(tab) => {
          setActiveTab(tab);
          closeSidebar();
        }}
        isOpen={sidebarOpen}
      />

      <main className="dashboard-content">
        {activeTab === TABS.analytics && <AnalyticsTab />}
        {activeTab === TABS.users && <UserManagement />}
      </main>
    </div>
  );
}

export default Dashboard;
